// extracted by mini-css-extract-plugin
module.exports = {"newsletterConfirmContainer":"newsletter-module--newsletter-confirm-container--2cjjb"};